module.exports = __webpack_public_path__ + "static/media/es-ca.e9062265.svg";